import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { platformName, platformOrder } from '../platformMeta';
import type { SocialPlatform } from '../types';
import { toggleValue } from './calendarFilterModel';
import { PlatformTile } from './PlatformTile';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Calendar; each part uses its own slice of it */
import styles from './PromoteCalendar.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ChannelFilterProps {
  selected: SocialPlatform[];
  onChange: (channels: SocialPlatform[]) => void;
}

/**
 * The five channel tiles (design a1). With no pick every channel shows. A tile that is off is grey
 * and keeps its mark (design a3).
 */
const ChannelFilterComponent: React.FC<ChannelFilterProps> = ({ selected, onChange }) => {
  const intl = useIntl();
  return (
    <div
      className={styles.chfilter}
      role="group"
      aria-label={intl.formatMessage({ id: 'app.sml.promote.calendar.filter.channels', defaultMessage: 'Channels' })}
    >
      {platformOrder.map((platform) => {
        const isOn = selected.length === 0 || selected.includes(platform);
        return (
          <button
            key={platform}
            type="button"
            className={clsx(styles.chbtn, !isOn && styles.chbtnOff)}
            aria-pressed={selected.includes(platform)}
            aria-label={platformName(platform)}
            onClick={() => onChange(toggleValue(selected, platform))}
          >
            <PlatformTile platform={platform} size="md" />
          </button>
        );
      })}
    </div>
  );
};

export const ChannelFilter = TypedMemo(ChannelFilterComponent);
